import React from 'react';
import Layout from '@/common/Layout';
import AdminPage from './components/AdminPage';

const Admin = () => {
  return (
    <>
      <Layout sider={false}>
        <AdminPage />
      </Layout>
    </>
  );
};

export default Admin;
